// Si la presentación nombra un tipo de envase/empaque (caneca, kit, saco...), eso es más útil
// como unidad que el peso/volumen que trae adentro — "CANECA DE 12 KG" debe verse como "Caneca",
// no "kg" (el kg ya describe cuánto contiene, no cómo se vende ni se cuenta en la cotización).
const CONTENEDORES = [
  { re: /\bCANECA\b/, label: 'Caneca' },
  { re: /\bKIT\b/, label: 'Kit' },
  { re: /\bSACO\b/, label: 'Saco' },
  { re: /\bROLLO\b/, label: 'Rollo' },
  { re: /\bMALLA\b/, label: 'Malla' },
  { re: /\bTARRO\b/, label: 'Tarro' },
  { re: /\bBALDE\b/, label: 'Balde' },
  { re: /\bCU[ÑN]ETE\b/, label: 'Cuñete' },
  { re: /\bGAL[OÓ]N(ES)?\b/, label: 'Galón' },
];

// Extrae una unidad de medida corta a partir del texto libre de presentación del catálogo
// (ej. "CANECA DE 16 KG" → "Caneca", "KIT 1 GL" → "Kit", "1,5 KG" sin envase nombrado → "kg").
// Si no reconoce ningún patrón, cae en 'Unidad' — el campo siempre queda editable a mano.
export function extraerUnidad(presentacion) {
  if (!presentacion) return 'Unidad';
  const s = presentacion.toUpperCase();
  const contenedor = CONTENEDORES.find(c => c.re.test(s));
  if (contenedor) return contenedor.label;
  if (/\bKG\b/.test(s)) return 'kg';
  if (/\bGL\b/.test(s)) return 'gal';
  if (/\bL\b|LITROS?/.test(s)) return 'L';
  if (/\bML\b/.test(s)) return 'mL';
  if (/\bM2\b/.test(s)) return 'm²';
  if (/\bG\b|GRAMOS?/.test(s)) return 'g';
  return 'Unidad';
}
